{
    "actions": {
        "page": {
            "add_contracts": {
                "title": "Assign contracts",
                "gateway": "Gateway contracts",
                "external": "External contracts"
            }
        },
        "row": {
            "update_label": "Update label",
            "remove": "Delete",
            "domiciliation": "Domiciliation card"
        }
    },
    "application": {
        "ACCORDEMV": "Accord EMV",
        "AMEX": "Amex On premise",
        "AMEXCLESS": "Amex Contactless",
        "CASHAGENCE": "Cash-Agency",
        "CBCLESS": "Contactless Payment",
        "CBEMV": "On premise Payment",
        "CBENSEIGNE": "Aurore",
        "CBVAD": "MOTO Payment",
        "CHEQUE-ELC": "Cheque scan",
        "CMCICSCHEME": "CUP Crédit Mutuel",
        "CONECS": "CONECS",
        "CONECSCLESS": "CONECS Contactless",
        "CUPNATIXIS": "CUP Natixis",
        "DCCFCC": "DCC Global Blue",
        "DCCFEXCO": "DCC Fexco",
        "DCC NATIXIS": "DCC Natixis",
        "DCCPLBS": "DCC PLBS",
        "FINTRAX": "Fintrax",
        "JCBEMV": "JCB On premise",
        "JCBVAD": "JCB MOTO Payment",
        "LASERCOFINOGA": "Laser Cofinoga",
        "MULTISSIME": "Multissime",
        "NXSMULTI": "CUP-Diners-Discover Natixis",
        "OPTALION": "Optalion LCL",
        "P3FEMV": "Installments EMV",
        "PASSCAREFOUR": "Pass Carrefour",
        "PAYLUDD": "Payludd",
        "PLBS+": "PLBS+",
        "PLBS": "PLBS",
        "PLBSGCB": "PLBS GCB",
        "PNFOZITO": "OZITO Installments",
        "POINTVERT": "Green Point",
        "PREAUTOCMUT": "Pré-author. Crédit Mutuel",
        "QUASI-CASH": "Casino Cash",
        "RELAISCE": "CE Relay",
        "SOFINCO": "Sofinco",
        "UNKNOWN_APPLICATION": "Unknown application",
        "ALMA": "ALMA",
        "UPI_CA_CONTACT": "UPI CA Contact",
        "UPI_CA_SANS_CONTACT": "UPI CA Contactless",
        "TOP3_3XCB": "TOP3 3XCB"
    },
    "ert": {
        "10": "10 - On premise Payment",
        "20": "20 - MOTO Payment",
        "41": "41 - Unattended payment class I ADM",
        "42": "42 - Unattended payment class II.1 ADM",
        "43": "43 - Unattended payment with mandatory client authentication",
        "45": "45 - Unattended payment class I SST",
        "46": "46 - Unattended payment class II.1 SST",
        "60": "60 - Quasi Cash",
        "80": "80 - PLBS",
        "empty": "-",
        "UNKNOWN": "Unknown"
    },
    "filter": {
        "placeholder": {
            "contract": "Filter by contract number",
            "rank": "Filter by rank",
            "bank_code": "Filter by bank code",
            "label": "Filter by label 2",
            "merchant_label": "Filter by label",
            "x25_address": "Filter by X25 Unit",
            "serial_number": "Filter by serial #",
            "manufacturer": "Filter by manufacturer",
            "itp": "Filter by ITP",
            "registration_number": "Filter by CRN",
            "legal_name": "Filter by merchant",
            "last_iccid": "Filter by SIM",
            "model": "Filter by label equipment",
            "specification": "Filter by specification",
            "bulletins": "Filter by bulletins",
            "cb_approval": "Filter by CB agreement #",
            "cb_version": "Filter by CB version",
            "pci_version": "Filter by PCI version",
            "pci_pp_version": "Filter by PCI PP version",
            "idsa": "Filter by IDSA",
            "mcc": "Filter by MCC",
            "merchant_name": "Filter by merchant name",
            "legal_and_business_name": "Filter by business name",
            "ert_code": "Filter by ERT code"
        }
    },
    "keys": {
        "application": "Application",
        "contract_number": "Contract",
        "rank": "Rank",
        "bank_code": "Bank code",
        "x25_address": "X25 Unit",
        "serial_number": "Serial #",
        "manufacturer": "Manufacturer",
        "itp": "ITP",
        "cb_version": "BC",
        "registration_number": "CRN",
        "legal_name": "Merchants",
        "label": "Contract label 2",
        "merchant_label": "Contract label",
        "last_iccid": "SIM",
        "last_remote_collection_date": "Last remote collection",
        "created_at": "Created at",
        "added_at": "Added at",
        "last_ssl_version": "Certificate",
        "model": "Label equipment",
        "specification": "Specifications",
        "bulletins": "Bulletins",
        "ert_code": "ERT",
        "cb_approval": "CB agreement #",
        "cb_approval_date": "CB agreement date",
        "pci_version": "PCI version",
        "pci_expiration_date": "PCI end date",
        "pci_pp_version": "PCI PP version",
        "pci_pp_expiration_date": "PCI PP end date",
        "expiration_date": "End of sale date",
        "end_of_deployment_date": "End of deployment date",
        "end_of_use_date": "End of life date",
        "idsa": "IDSA",
        "mcc": "MCC",
        "merchant_name": "Merchant name",
        "legal_and_business_name": "Business name"
    },
    "modal": {
        "update_label": {
            "title": "Modify contract label",
            "text": "Contract label",
            "success": "Contract successfully updated !",
            "error": "An error occurred while updating the contract"
        },
        "delete": {
            "title": "Confirmation of deletion",
            "text": "Payment informations for this contract will not be deleted and remain accessible. This action will lead to the cancellation of these contracts associated with groups.",
            "success": "Contract successfully deleted !",
            "error": "An error occurred while deleting the contract",
            "warning": "Please confirm your deletion request for this contract"
        },
        "domiciliation": {
            "title": "Domiciliation card",
            "application": "Application",
            "contract_number": "Contract",
            "title_contract_only": "Contract #{{number}}",
            "iso_track": "ISO track",
            "copy_to_clipboard": {
                "copy": "Copy",
                "success": "Copied to Clipboard"
            }
        },
        "import": {
            "explanations": {
                "header": "You can add contracts to a merchant account by CSV file. The file to import must contain the following 5 columns :",
                "contract": "contrat : 7-digit contract number",
                "application": "application : identifies the contract application (CBEMV, CBCLESS, AMEX, ALMA...)",
                "bank_code": "bank_code : acquirer bank code",
                "rank": "rank : 3-digit rank number. It can contain one or more values separated by commas (example \"001,002,007\"), define a range (example 001-010) or be empty to allow all ranks",
                "contract_label": "contract_label : label to identify each of the contracts",
                "warning": "Warning : only a contract existing on the gateway will be added to a merchant account. If a contract is not known to our gateway, it will not be added."
            },
            "error": {
                "BAD_FILE_FORMAT_EXCEPTION": "The file format is invalid.",
                "TOO_MANY_RESOURCES": "The import of contracts by CSV file is limited to 10,000 contracts",
                "UNEXPECTED_ERROR": "An unexpected error occurred.",
                "INVALID_REQUEST": "An unexpected error occurred.",
                "alreadyExistingMerchantContract": "This merchant contract already exists",
                "bankCodeIsInvalid": "Invalid bank code",
                "contractIsInvalid": "Invalid contract number",
                "contractLabelIsInvalid": "Label too long",
                "rankIsInvalid": "Invalid rank",
                "applicationIsInvalid": "Invalid application",
                "get_example_file": "Please download the example file.",
                "header": "The addition of contracts has been partially performed due to the presence of errors in the CSV. Below is the list of contract numbers that have not been created and their errors :",
                "footer": "You can correct these errors and try the contract creation operation again."
            },
            "confirmation": "This operation will add {{numberOfContracts}} contracts to the merchant account. Do you want to continue ?",
            "success": "Contracts added successfully !"
        }
    },
    "rank": {
        "all": "All ranks",
        "range": "From {{from}} to {{to}}"
    },
    "tooltips": {
        "mail_to_unknown_application": "Click here to tell us application's name"
    }
}